export default angular
  .module('doxy.common.components.tooltip', [])
  .directive('dxTooltipContainer', function ($timeout) {
    const TOOLTIP_WIDTH = 370;

    function toggleRight(element) {
      element.classList.remove('dx-tooltip__container-left');
      element.classList.add('dx-tooltip__container-right');
    }

    function toggleLeft(element) {
      element.classList.remove('dx-tooltip__container-right');
      element.classList.add('dx-tooltip__container-left');
    }

    return function (scope, element) {
      $timeout(() => {
        const child = element[0];

        if (child) {
          const rect = child.getBoundingClientRect();
          if (rect.right + TOOLTIP_WIDTH > window.innerWidth)
            return toggleLeft(element[0]);
          toggleRight(element[0], rect.width);
        }
      });
    };
  }).name;
